import interactions from '@/store/modules/authentication/interactions';
import tokens from '@/store/modules/authentication/tokens';
import user from '@/store/modules/authentication/user';

export default {
    interactions,
    tokens,
    user,
};
